import ready, { HTML } from './utils'
import { initHasDropDown, initHoverJs } from './components/initHover'
import initInfoTooltip from './components/tooltip'
import initCardTooltip from './components/initCardTooltip'

ready(() => {
    HTML.classList.add('is-loaded')
    initHasDropDown()
    initHoverJs()
    initInfoTooltip()
    initCardTooltip()
})
